import ShippingUuidFilter from '@/common/shippingUuid.filter'

const TransactionsListExtras = () => import(/* webpackChunkName: "panels" */ '@/components/Transactions/ListExtras')
const ListItemUuidCopy = () => import('@/components/Engine/ListItemUuidCopy')
const TransactionsListItemAccountOwner = () => import(/* webpackChunkName: "panels" */ '@/components/Transactions/ListItemAccountOwner')
const ListItemDateTime = () => import('@/components/Engine/ListItemDateTime')
const TransactionsListActions = () => import(/* webpackChunkName: "panels" */ '@/components/Transactions/ListActions')

const transactionsModel = vm => ({
  title: vm.$gettext('Transactions'),
  endpoint: 'accounts/transactions',
  allowNew: false,
  countrize: 'country_iso_code',
  allowSelect: true,
  listExtrasComponent: TransactionsListExtras,
  fields: [
    {
      key: 'id',
      sortable: true,
      component: value => ({
        is: ListItemUuidCopy,
        props: { value }
      })
    },
    {
      key: 'type',
      label: vm.$gettext('Type'),
      sortable: true,
      formatter: value =>
        '<span class="' + (value === 'credit' ? 'text-success' : 'text-danger') + ' text-capitalize">' + value + '</span>'
    },
    {
      key: 'relationship',
      label: vm.$gettext('Relationship'),
      sortable: false,
      editable: false,
      required: false,
      formatter: value => '<span class="text-capitalize">' + value + '</span>'
    },
    {
      key: 'account',
      label: vm.$gettext('Account'),
      sortable: false,
      editable: false,
      required: false
    },
    {
      key: 'reason',
      label: vm.$gettext('Reason'),
      sortable: true,
      editable: true,
      required: true,
      formatter: value =>
        '<span class="' +
        (value === 'delivered' ? 'text-success' : (value === 'incidence' ? 'text-warning' : 'text-dark')) +
        ' text-uppercase">' + value + '</span>'
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference'),
      editable: true,
      required: true,
      formatter: value => '<strong>' + (value === null || value === undefined ? '' : value) + '</strong>'
    },
    {
      key: 'account_owner',
      label: vm.$gettext('Account Owner'),
      editable: false,
      required: false,
      component: (value, key, item) => ({
        is: TransactionsListItemAccountOwner,
        props: { item }
      })
    },
    {
      key: 'amount',
      label: vm.$gettext('Amount'),
      editable: true,
      required: true,
      formatter: (value, key, item) => (item.type === 'credit' ? '-' : '') + item.amount + ' ' + item.currency
    },
    {
      key: 'shipping_id',
      label: vm.$gettext('Related to'),
      sortable: true,
      editable: true,
      required: true,
      formatter: (value, key, item) => {
        let html = ''
        if (item.is_outsourcing) {
          html += '<span class="badge badge-danger">3P</span>'
        }
        if (value) {
          html +=
            '<span class="badge badge-info">' +
            vm.$gettext('Shipping') +
            '</span><br><a href="/edit/shippings/' +
            value +
            '" target="_blank">#' +
            ShippingUuidFilter(value) +
            '</a>'
        }
        if (item.accounting_note && item.accounting_note.service) {
          if (value) {
            html += '<br>'
          }
          html +=
            '<span class="badge badge-info">' +
            vm.$gettext('Service') +
            '</span><br>' +
            item.accounting_note.service.name
        }
        if (item.fleet_rental_order_id) {
          if (value) {
            html += '<br>'
          }
          html +=
            '<span class="badge badge-info">' +
            vm.$gettext('Fleet Rental Order') +
            '</span><br><a href="/edit/fleet-rental-orders/' +
            item.fleet_rental_order_id +
            '" target="_blank">#' +
            item.fleet_rental_order_id +
            '</a>'
        }
        return html
      }
    },
    {
      key: 'applied_by_id',
      label: vm.$gettext('Applied By'),
      sortable: true,
      editable: true,
      formatter: (value, key, item) => {
        return '<a href="/edit/users/' + value + '" target="_blank">#' + value + '</a>'
      }
    },
    {
      key: 'visibility',
      editable: true,
      required: true,
      label: vm.$gettext('Take'),
      formatter: value => (value === 'all' ? vm.$gettext('YES') : vm.$gettext('NO'))
    },
    {
      key: 'imputation_date',
      label: vm.$gettext('Imputation Date'),
      sortable: true,
      editable: true,
      required: true,
      component: value => ({
        is: ListItemDateTime,
        props: { value }
      })
    },
    {
      key: 'created_at',
      label: vm.$gettext('Created At'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'updated_at',
      label: vm.$gettext('Updated At'),
      sortable: true,
      editable: true
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country'),
      editable: true,
      required: true,
      description: vm.$gettext('Country ISO 3166-1 alpha 2 code (ie. AR or BR)')
    },
    {
      key: 'actions',
      label: vm.$gettext('Actions'),
      hidden: true,
      component: (value, key, item, row) => ({
        is: TransactionsListActions,
        props: { row },
        on: {
          refresh: () => vm.$root.$emit('bv::refresh::table', 'apiListTable')
        }
      })
    }
  ],
  filters: [
    'id',
    'name',
    'relationship',
    'type',
    'reason',
    'amount',
    'shipping_id',
    'fleet_rental_order_id',
    'country_iso_code'
  ],
  exclude: ['account', 'updated_at'],
  includes: ['account.owner', 'shipping', 'accounting_note.service']
})

export default transactionsModel
